import React from 'react';

const variants = {
  primary: `
    bg-brand-500 text-white
    hover:bg-brand-600
    focus:ring-2 focus:ring-brand-500 focus:ring-offset-2
    dark:focus:ring-offset-boxdark
  `,
  secondary: `
    bg-gray-2 text-body
    hover:bg-gray
    dark:bg-dark-2 dark:text-bodydark dark:hover:bg-dark-3
  `,
  outline: `
    border border-stroke bg-transparent text-body
    hover:bg-gray-2
    dark:border-strokedark dark:text-bodydark dark:hover:bg-dark-2
  `,
  danger: `
    bg-danger text-white
    hover:bg-opacity-90
  `,
  success: `
    bg-success text-white
    hover:bg-opacity-90
  `,
  ghost: `
    bg-transparent text-body
    hover:bg-gray-2
    dark:text-bodydark dark:hover:bg-dark-2
  `,
};

const sizes = {
  sm: 'px-4 py-2 text-sm',
  md: 'px-5 py-3 text-base',
  lg: 'px-6 py-4 text-lg',
};

const Button = ({
  children,
  variant = 'primary',
  size = 'md',
  type = 'button',
  disabled = false,
  loading = false,
  icon: Icon,
  iconPosition = 'left',
  className = '',
  onClick,
  ...props
}) => {
  const baseClasses = `
    inline-flex items-center justify-center gap-2
    rounded-lg font-medium
    transition-all duration-200
    disabled:opacity-50 disabled:cursor-not-allowed
  `;

  return (
    <button
      type={type}
      disabled={disabled || loading}
      onClick={onClick}
      className={`${baseClasses} ${variants[variant]} ${sizes[size]} ${className}`}
      {...props}
    >
      {loading ? (
        <>
          <svg
            className="animate-spin h-5 w-5"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            />
          </svg>
          <span>Loading...</span>
        </>
      ) : (
        <>
          {Icon && iconPosition === 'left' && <Icon size={20} />}
          {children}
          {Icon && iconPosition === 'right' && <Icon size={20} />}
        </>
      )}
    </button>
  );
};

export default Button;
